import React, { useEffect, useState } from 'react';
import DataTable from '../common/DataTable';
import { numOfPage, RateCardColumns } from '../../constant';
import BatchPagination from '../batch/BatchPagination';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchServiceRateCard } from '../../store/actions/serviceRateCard.action';
import _ from 'lodash';
import LoaderSpinner from '../common/Loader';
import ProductListingFilter from '../Inventory/Product/ProductListingFilter';
import SearchCarrierConnect from '../CarrierConnect/SearchCarrierConnect';

const Accounts = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { productPrevState } = useSelector((state) => state.employee);
    const { serviceRateCardList, serviceRateCardListStatus } = useSelector((state) => state.serviceRateCardReducer);
    const [loader, setLoader] = useState(false);
    const [sellerList, setSellerList] = useState([]);
    const [allSellers, setAllSellers] = useState([]);
    const [rateCardListData, setRateCardListData] = useState([]);
    const { showAccountingMenu } = useSelector((state) => state.accountingReducer);

    let dataLoad = {
        pageIndex: 1,
        pageSize: 30,
        totalPages: 1,
        sortColumn: '',
        sortOrder: 'DESCENDING',
        searchKeyword: '',
        sellerIdList: [],
        companyIdList: [],
        showFilter: false,
        showSearch: false,
    }

    const [filterData, setfilterData] = useState(dataLoad);

    useEffect(() => {
        if (serviceRateCardListStatus === 'PENDING') {
            setLoader(true);
        } else {
            setLoader(false);
        }
        if (serviceRateCardListStatus === 'SUCCESS' && serviceRateCardList?.RateCards?.length) {
            setfilterData({ ...filterData, totalPages: Math.ceil(serviceRateCardList.TotalRecords / filterData.pageSize) });
            let list = serviceRateCardList?.RateCards.map(item => {
                return {
                    ...item,
                    id: item.CompanySellerId,
                }
            });
            setRateCardListData(list);
        }
    }, [serviceRateCardListStatus]);

    useEffect(() => {
        if (!_.isEmpty(productPrevState)) {
            setfilterData({ ...filterData, ...productPrevState });
        } else {
            setfilterData(dataLoad);
        }
    }, []);

    useEffect(() => {
        getAllRateCards();
    }, [filterData.pageSize, filterData.pageIndex, filterData.sortColumn, filterData.sortOrder]);

    const getAllRateCards = () => {
        let data = {
            ...filterData,
            companyIdList: _.map(filterData.companyIdList, 'Id'),
            sellerIdList: _.map(filterData.sellerIdList, 'id'),
            searchKeyword: filterData.searchKeyword?.trim(),
        };
        dispatch(fetchServiceRateCard(data));
    };

    const handleAction = (item, type, isView) => {
        navigate(`/accounting/service-rate-card/rate-card-${item.CompanySellerId}`, {
            state: {
                rateCardDetails: item,
            }
        });
    }

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            sortColumn: key,
            sortOrder: newSortOrder,
        });
    }

    const handleSearchText = (value) => {
        setfilterData({ ...filterData, searchKeyword: value });
    }

    const handleSearchFilter = () => {
        if (filterData.pageIndex !== 1) {
            setfilterData({ ...filterData, pageIndex: 1 });
        } else {
            getAllRateCards();
        }
    };

    const handleResetSearch = (e, type) => {
        let data = JSON.parse(JSON.stringify(dataLoad));
        data.showFilter = false;
        data.pageSize = filterData.pageSize;
        setfilterData(data);
        dispatch(fetchServiceRateCard(data));
        setSellerList(allSellers);
        return;
    }

    const handleReset = (e, type) => {
        if (type === 'clear') {
            let data = JSON.parse(JSON.stringify(dataLoad));
            data.showFilter = false;
            data.pageSize = filterData.pageSize;
            setfilterData(data);
            dispatch(fetchServiceRateCard(data));
            setSellerList(allSellers);
            return;
        }
        setfilterData({ ...filterData, searchKeyword: '' });
    };

    const handleFilterToggle = (key, value) => {
        setfilterData({ ...filterData, [key]: value });
    };

    const handleFilter = () => {
        let cloneFilterData = {
            ...filterData,
            companyIdList: _.map(filterData.companyIdList, 'Id'),
            sellerIdList: _.map(filterData.sellerIdList, 'id'),
            pageIndex: 1,
            searchKeyword: filterData.searchKeyword?.trim(),
        };
        if (filterData.pageIndex !== 1) {
            setfilterData({ ...filterData, pageIndex: 1 });
        } else {
            dispatch(fetchServiceRateCard(cloneFilterData));
        }
    };


    return (
        <div className={`${showAccountingMenu ? 'col-10' : 'col-12'}`}>
            <div className=''>
                <div className="main__tile_heading cus-btn-include-sec">
                    <span>
                        Service Rate Card
                    </span>
                    <div className="top_right_button_container">
                        <div className="top_right_button_container">
                            <button
                                className="btn cus-seconday-bg-btn top-btn"
                                disabled
                            >
                                Bulk Upload
                            </button>

                            <button
                                className="btn cus-seconday-bg-btn top-btn addNewProduct"
                                onClick={() => handleFilterToggle('showFilter', !filterData.showFilter)}
                            >
                                Filter
                            </button>
                        </div>
                    </div>
                </div>
                <div className='zIndex2'>
                    <SearchCarrierConnect
                        searchKeyword={filterData.searchKeyword}
                        handleSearchText={handleSearchText}
                        handleSearchFilter={handleSearchFilter}
                        handleReset={handleResetSearch}
                        placeholderText="Search by Company or Seller Name"
                    />
                </div>
                {serviceRateCardListStatus === 'PENDING' && <LoaderSpinner />}

                {filterData.showFilter && (
                    <ProductListingFilter
                        showFilter={filterData.showFilter}
                        dispatch={dispatch}
                        useSelector={useSelector}
                        filterData={filterData}
                        setfilterData={setfilterData}
                        fetchProductList={handleFilter}
                        handleReset={handleReset}
                        sellerList={sellerList}
                        setSellerList={setSellerList}
                        allSellers={allSellers}
                        setAllSellers={setAllSellers}
                    />
                )}

                <div className="main_content cus-page-content-sec srch-pt0">
                    <div className="main_content_table_history">
                        <div className="tableFixHead incomingTbl">
                            <DataTable
                                headers={RateCardColumns}
                                tableData={rateCardListData}
                                actionType={3}
                                handleAction={handleAction}
                                handleSortingColumn={handleSortingColumn}
                                tableDataStatus={serviceRateCardListStatus}
                                filterData={filterData}
                            />
                        </div>
                    </div>
                    <BatchPagination
                        gridData={rateCardListData}
                        totalVisualRecords={rateCardListData?.length}
                        numberOfPage={filterData.pageSize}
                        numOfPage={numOfPage}
                        loader={loader}
                        currentPage={filterData.pageIndex}
                        totalPages={filterData.totalPages}
                        totalRecords={serviceRateCardList.TotalRecords}
                        setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                        setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value })}
                    />
                </div>
            </div>
        </div>
    );
}

export default Accounts;